// extracted by mini-css-extract-plugin
export default {"alertBody":"alert_alertBody__Cf3nE","content":"alert_content__-f4Vz","statusImg":"alert_statusImg__HNNOC"};